import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCol,{attrs:{"cols":"12","md":"11"}},[_c('Titles',{attrs:{"type":1,"text":'Visão'}}),_c('pre',{staticClass:"club-font"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }